import { PureComponent } from 'react';
import t from 'prop-types';

class PopoverWrapperContent extends PureComponent {
  render() {
    const { children } = this.props;

    return children;
  }
}

if (process.env.NODE_ENV !== 'production') {
  PopoverWrapperContent.propTypes = {
    children: t.node.isRequired
  };
}

export default PopoverWrapperContent;
